// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6bca4e94ca1928e3","5979":"0e4488c83a35e92e"}[chunkId] + ".css";
};